export enum PriceMasterFields {
    NO_OF_CHANGES = "noOfChanges",
    AVERAGE_COST = "averageCost",
    BASE_PRICE = "basePrice",
    BUNDLE_PRICING = "bundlePricing",
    CLEARANCE_PRICE = "clearancePrice",
    COMMERCIAL_PRICE = "commercialPrice",
    COMMERCIAL_SALES = "commercialSales",
    COMPETITOR_PRICING = "competitorPricing",
    CURRENCY = "currency",
    CURRENT_PRICE = "currentPrice",
    DIGITAL_VS_PHYSICAL_PRICING = "digitalVsPhysicalPricing",
    DISCOUNT_END_DATE = "discountEndDate",
    PRICE_START_DATE = "priceStartDate",
    PRICE_END_DATE = "priceEndDate",
    DISCOUNT_RATE = "discountRate",
    DISCOUNT_START_DATE = "discountStartDate",
    DISCOUNT_VALUE = "discountValue",
    EFFECTIVE_DATE = "effectiveDate",
    ITEM_COST_PRICE = "itemCostPrice",
    LICENSING_FEE = "licensingFee",
    MINIMUM_ADVERTISED_PRICE = "minimumAdvertisedPrice",
    NO_OF_CHANGES_IN_PRICE = "noOfChangesInPrice",
    ONLINE_SALES = "onlineSales",
    PRICE_CHANGE_DATE = "priceChangeDate",
    PRICE_ID = "priceId",
    PRICE_TREND = "priceTrend",
    PRICE_WITH_GST = "priceWithGST",
    PRICING_APPROVAL = "pricingApproval",
    PRICING_STRATEGY = "pricingStrategy",
    PRODUCT_ID = "productId",
    PRODUCT_NAME = "productName",
    REBATE_PRICE = "rebatePrice",
    RETAIL_SALES = "retailSales",
    ROYALTY = "royalty",
    SCAN_BACK = "scanBack",
    SELLING_PRICE = "sellingPrice",
    TAX_RATE = "taxRate",
    VOLUME_DISCOUNT = "volumeDiscount",
    PRODUCT_CODE = "productCode",
    TICKET_PRICE = "ticketPrice",
    PROMO_PRICE = "promoPrice",
    ELQ = "elq",
    STORE_CODE = "storeCode",
    TRADE_PRICE = "tradePrice",
    CHANNEL_PRICING = "channelpricing",
    WHOLE_SALE_PRICE = "wholesaleprice",
    DISCOUNT_PERCENTAGE = "discountpercentage"
}

export enum PriceMasterTabs {
    PRICING_DETAILS = "Pricing Details",
    PRICING_STRATEGY = "Pricing Strategy",
    PRICING_DISCOUNTS = "Pricing Discounts",
    FINANCIAL_DETAILS = "Financial Details",
    SALES_METRICS = "Sales Metrics",
}